import { createFileRoute } from "@tanstack/react-router";
import { BookingProvider } from "@/components/site/booking-context";
import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import { MobileBookingBar } from "@/components/site/MobileBookingBar";
import {
  MapAmenitiesBridge,
  MapFAQ,
  MapFinalCTA,
  MapIncludes,
  MapPageHero,
  ResortMapViewer,
  ResortQuickFacts,
  RVFitBridge,
  SiteRequestProcess,
  SiteTypePreview,
} from "@/components/site/map-page";
import { heroPreloadLink } from "@/data/optimized-images";
import { mapFaqs, resort } from "@/data/resort";
import { absoluteUrl } from "@/lib/site";
import heroMainAsset from "@/assets/auburn-hero-main.webp.asset.json";


const title = "Auburn RV Resort Map | RV Sites in Auburn, CA";
const description =
  "View the Auburn RV Resort map and explore the layout of RV sites and resort facilities in Auburn, California. Find your preferred site type and check availability.";
const ogImage = `https://auburnrvresort.com${heroMainAsset.url}`;


const schema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": ["LodgingBusiness", "Campground"],
      name: resort.name,
      description,
      telephone: resort.phone,
      email: resort.email,
      url: "/auburn-rv-map/",
      address: {
        "@type": "PostalAddress",
        streetAddress: resort.address.street,
        addressLocality: resort.address.city,
        addressRegion: resort.address.state,
        postalCode: resort.address.zip,
        addressCountry: "US",
      },
    },
    {
      "@type": "FAQPage",
      mainEntity: mapFaqs.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    },
  ],
};

export const Route = createFileRoute("/auburn-rv-map")({
  head: () => ({
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "website" },
      { property: "og:image", content: ogImage },
      { property: "og:image:width", content: "1322" },
      { property: "og:image:height", content: "936" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: ogImage },
    ],
    links: [{ rel: "canonical", href: absoluteUrl("/auburn-rv-map/") }, heroPreloadLink],
    scripts: [{ type: "application/ld+json", children: JSON.stringify(schema) }],
  }),
  component: AuburnRvMapPage,
});

function AuburnRvMapPage() {
  return (
    <BookingProvider>
      <Navbar />
      <main>
        <MapPageHero />
        <ResortQuickFacts />
        <ResortMapViewer />
        <SiteTypePreview />
        <MapIncludes />
        <RVFitBridge />
        <SiteRequestProcess />
        <MapAmenitiesBridge />
        <MapFAQ />
        <MapFinalCTA />
      </main>
      <Footer />
      <MobileBookingBar />
    </BookingProvider>
  );
}
